import styled from 'styled-components';

export const Card = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 132px;
  background-color: ${({ theme }) => theme.neutral_200};
  border: 1px solid ${({ theme }) => theme.neutral_200};
  border-radius: 8px;
  padding: 16px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.neutral_500};
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
  gap: 4px;

  .carrier-name {
    color: ${({ theme }) => theme.primary_300};
  }
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PrintLabel = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-end;
  gap: 4px;
  color: ${({ theme }) => theme.primary_300};
  text-decoration: underline;
`;
